/*
 * Behaviour for the desktop mega-menu (v2-header-mega-menu.liquid).
 *
 * The panel itself is shown/hidden purely in CSS (group-hover / group-focus-within),
 * so the menu still works with no JS. This script layers on:
 *
 *   1. Touch support — on no-hover devices (e.g. iPad landscape, >= 990px) the
 *      first tap on a parent item opens its panel and a second tap follows the
 *      link, so the submenu can actually be browsed instead of navigating away.
 *   2. aria-expanded kept in sync with the panel's real open/closed state.
 *   3. Escape dismisses the open panel and returns focus to its trigger.
 *
 * Mouse hover behaviour on pointer devices is left untouched.
 */
(function () {
  const canHover = window.matchMedia('(hover: hover)');

  function init() {
    const nav = document.querySelector('.header__inline-menu');
    if (!nav) return;

    const groups = Array.from(nav.querySelectorAll('li.group'));

    function setExpanded(group, value) {
      const trigger = group && group.__navTrigger;
      if (trigger) trigger.setAttribute('aria-expanded', value ? 'true' : 'false');
    }

    function closeAll(except) {
      groups.forEach((group) => {
        if (group === except) return;
        group.classList.remove('nav-open');
        setExpanded(group, false);
      });
    }

    groups.forEach((group) => {
      const trigger = group.querySelector(':scope > a[aria-haspopup="true"]');
      const panel = group.querySelector(':scope > [role="menu"]');
      if (!trigger || !panel) return;

      group.__navTrigger = trigger;
      trigger.setAttribute('aria-expanded', 'false');

      // Keep aria-expanded in step with hover/focus (visibility is CSS-driven).
      group.addEventListener('mouseenter', () => {
        group.classList.remove('nav-collapsed');
        setExpanded(group, true);
      });
      group.addEventListener('mouseleave', () => {
        if (!group.classList.contains('nav-open')) setExpanded(group, false);
      });
      group.addEventListener('focusin', () => {
        group.classList.remove('nav-collapsed');
        setExpanded(group, true);
      });
      group.addEventListener('focusout', (event) => {
        // Only act when focus actually leaves the group.
        if (group.contains(event.relatedTarget)) return;
        group.classList.remove('nav-open', 'nav-collapsed');
        setExpanded(group, false);
      });

      // Touch: first tap opens, second tap follows the link.
      trigger.addEventListener('click', (event) => {
        if (canHover.matches) return;
        if (!group.classList.contains('nav-open')) {
          event.preventDefault();
          closeAll(group);
          group.classList.remove('nav-collapsed');
          group.classList.add('nav-open');
          setExpanded(group, true);
        }
      });
    });

    // Close the open panel when clicking/tapping outside the nav.
    document.addEventListener('click', (event) => {
      if (!nav.contains(event.target)) closeAll(null);
    });

    // Escape dismisses the open panel and returns focus to its trigger.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;

      const focused = groups.find((group) => group.contains(document.activeElement));
      closeAll(null);

      if (focused) {
        // nav-collapsed force-hides the panel even though the trigger keeps focus.
        focused.classList.add('nav-collapsed');
        setExpanded(focused, false);
        if (focused.__navTrigger) focused.__navTrigger.focus();
      }
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
